export var createAddAudioParamConnections = function createAddAudioParamConnections(audioParamConnectionsStore) {
  return function (audioParam, audioParamRenderer) {
    audioParamConnectionsStore.set(audioParam, {
      activeInputs: new Set(),
      passiveInputs: new WeakMap(),
      renderer: audioParamRenderer
    });
  };
};